import { forwardRef, useState } from 'react';
import { cn } from '../../lib/cn';

export const Input = forwardRef(function Input(
  {
    className,
    style,
    leftIcon: LeftIcon,
    rightIcon: RightIcon,
    rightSlot,
    invalid,
    type = 'text',
    onFocus,
    onBlur,
    ...props
  },
  ref
) {
  const [focused, setFocused] = useState(false);

  return (
    <div className="relative w-full">
      {LeftIcon && (
        <LeftIcon
          size={15}
          strokeWidth={2}
          className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2"
          style={{ color: focused ? 'var(--dash-primary)' : 'var(--dash-text-muted)' }}
        />
      )}
      <input
        ref={ref}
        type={type}
        className={cn(
          'h-11 w-full rounded-xl text-sm outline-none transition-all duration-200',
          'placeholder:text-[var(--dash-text-faint)]',
          LeftIcon ? 'pl-10' : 'pl-4',
          RightIcon || rightSlot ? 'pr-10' : 'pr-4',
          className
        )}
        style={{
          background: 'var(--dash-surface-subtle)',
          color: 'var(--dash-text)',
          border: invalid
            ? '1px solid rgba(254,52,86,0.6)'
            : focused
              ? '1px solid var(--dash-primary)'
              : '1px solid var(--dash-border)',
          boxShadow: focused
            ? '0 0 0 4px rgba(173,52,254,0.12)'
            : invalid
              ? '0 0 0 4px rgba(254,52,86,0.08)'
              : 'none',
          ...style,
        }}
        onFocus={(e) => {
          setFocused(true);
          onFocus?.(e);
        }}
        onBlur={(e) => {
          setFocused(false);
          onBlur?.(e);
        }}
        {...props}
      />
      {RightIcon && (
        <RightIcon
          size={15}
          strokeWidth={2}
          className="pointer-events-none absolute right-3.5 top-1/2 -translate-y-1/2"
          style={{ color: 'var(--dash-text-muted)' }}
        />
      )}
      {rightSlot && (
        <div className="absolute right-2 top-1/2 -translate-y-1/2">{rightSlot}</div>
      )}
    </div>
  );
});
